import React, { ReactNode } from "react";
import "../../assets/styles/components/table.scss";

interface TableColumnProps {
  children: ReactNode;
  align?: string;
  className?: string;
  width?: string;
  colspan?: number;
  rowspan?: number;
  padding?: string;
  backgroundColor?: string;
  style?: any;
  fixed?: boolean;
  onClick?: () => void;
}

const TableColumn: React.FC<TableColumnProps> = ({
  children,
  align = "left",
  className,
  onClick,
  padding = "0px 10px",
  width,
  colspan = 1,
  rowspan = 1,
  backgroundColor,
  fixed = false,
  style = {},
}) => {
  const left = "left";
  const center = "center";
  const right = "right";

  let background = "transparent";

  if (children == "มัดจำ") {
    background = "#FEEFC7";
    className = "color-sb02";
  } else if (children == "จ่ายเต็มจำนวน" || children == "ชำระเงินแล้ว") {
    background = "#C7F0D8";
    className = "color-sb01";
  } else if (children == "ค้างชำระ") {
    background = "#FFCDCD";
    className = "color-sb03";
  }

  return (
    <td
      className={className}
      align={align == "center" ? center : align == "right" ? right : left}
      width={width}
      onClick={onClick}
      colSpan={colspan}
      rowSpan={rowspan}
      style={{
        backgroundColor: backgroundColor ? backgroundColor : background,
        padding: !padding && fixed ? "0" : padding,
        ...style,
      }}
    >
      {children}
    </td>
  );
};

export default TableColumn;
